import React, { useState } from "react";

import { addUser } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate } from "utils";

import { adminRoles } from "enums";

import { AdminHead, AdminRolesDrawer, Button, Col, Form, Input, Link, MainPage, Option, Row, Select, Message as message } from "components";

export const AdminUserAdd = () => {
  const [loading, setLoading] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const complete = (v) => {
    setLoading(true);

    addUser({
      ...v,
      ...{ signal },
    })
      .then(() => {
        navigate("/settings");
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline="Add an admin user"
        link="/settings/users"
        tooltipText="Back to admin users"
        description={
          <>
            Add an admin user here - you will set their access level. They will receive an email and be able to change their password.{" "}
            <Link tracking={false} onClick={() => setShowDrawer(true)}>
              View admin role details
            </Link>
            .
          </>
        }
      />
      <Row className="midi-form">
        <Col>
          <Form name="confirm" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
            <Row>
              <Col sm={12} md={12}>
                <Input name="firstName" label="First name" rules={[{ required: true }]} />
              </Col>
              <Col sm={12} md={12}>
                <Input name="lastName" label="Last name" rules={[{ required: true }]} />
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12}>
                <Input name="email" label="Email address" rules={[{ required: true, type: "email" }]} />
              </Col>
              <Col sm={6} md={6}>
                <Select name="role" label="User role" rules={[{ required: true }]}>
                  {adminRoles.map((role, i) => (
                    <Option value={role.role} key={i}>
                      {role.label ?? role.role}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <AdminRolesDrawer visible={showDrawer} onClose={() => setShowDrawer(false)} />
    </MainPage>
  );
};
